import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: localStorage.getItem('user'),
    token: localStorage.getItem('token'),
    vrs: localStorage.getItem('vrs')
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
    },
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_VRS(state, vrs) {
      state.vrs = vrs;
    }
  },
  actions: {
    setUser({ commit }, user) {
      commit('SET_USER', user);
      localStorage.setItem('user',user)
    },
    setToken({ commit }, token) {
      commit('SET_TOKEN', token);
      localStorage.setItem('token',token)
    },
    setVrs({ commit }, vrs) {
      commit('SET_VRS', vrs);
      localStorage.setItem('vrs', vrs);
    }
  },
  getters: {
    user: state => state.user,
    token: state => state.token,
    vrs: state => state.vrs
  }
});
